import { Injectable, OnDestroy, ViewChild, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { PrefabConfigurationService } from '../prefab-configuration.service';
import {I18nService, ProjectService} from "@wms/services";
import { AppEnv, Config, KeyValue } from '../prefab-configuration.utils';
import { NgForm } from '@angular/forms';

@Injectable()
export class BasePrefabConfigTab implements OnDestroy {
  public resetFormSubscription: Subscription;
  public registerDestroyListener = new Subscription();
  public locale: any;
  public i18nService: I18nService;
  public prefabConfigService: PrefabConfigurationService;
  public projectService: ProjectService;
  prefabConfig: Config;
  initialResources:any;
  initialPackaging:any;
  initialAppEnv:any;

  resourcesForm:NgForm;
  packagingForm:NgForm;
  appEnvForm:NgForm;
  eventsForm: NgForm;
  methodsForm:NgForm;

  initialAppEnvironmentProps: any;
  appEnvironmentProps: AppEnv[];
  appEnvironment: KeyValue;
  errorKey: boolean
  errorValue: boolean;
  initialEvents: any;
  initialMethods:any

  constructor() {
    this.i18nService = inject(I18nService);
    this.prefabConfigService = inject(PrefabConfigurationService)
    this.projectService = inject(ProjectService)

    this.locale = this.i18nService.getMessages();

     this.resetFormSubscription = this.prefabConfigService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        // Resource Tabe
        this.resourcesForm?.form.reset(this.initialResources);
        this.prefabConfig = this.prefabConfigService.getConfig();

        // Packaging Tab
        this.packagingForm?.form.reset(this.initialPackaging);

        // appEnvForm Tab
        this.appEnvForm?.form.reset(this.initialAppEnv);
        this.appEnvironmentProps = this.initialAppEnvironmentProps ? [...this.initialAppEnvironmentProps] : [];
        this.appEnvironment = { key: '', value: '' };
        this.errorKey       = false;
        this.errorValue     = false;

        // event Tab
        this.eventsForm?.form.reset(this.initialEvents);
        // methodsForm Tab
        this.methodsForm?.form.reset(this.initialMethods);

      } else {
        this.initialResources =  this.resourcesForm.form.value;
        this.initialPackaging =  this.packagingForm.form.value
        this.initialAppEnv =  this.appEnvForm.form.value;
        this.initialEvents =  this.eventsForm.form.value;
        this.initialMethods =  this.methodsForm.form.value;
      }
    });
  }

  ngOnDestroy(): void {
    this.resetFormSubscription?.unsubscribe();
    this.registerDestroyListener.unsubscribe();
  }
}
